import { ReactNode, createContext, useState, useContext } from 'react';
import { TableModalProviderProps, TableModalContextProps } from './types';

export const TableModalContext = createContext<TableModalContextProps | null>(
  null
);

export const TableModalProvider = ({
  children
}: TableModalProviderProps): JSX.Element => {
  const [isTableModalOpen, setIsTableModalOpen] = useState<boolean>(false);
  const [tableModalContent, setTableModalContent] = useState<ReactNode>(null);

  const context: TableModalContextProps = {
    isTableModalOpen,
    setIsTableModalOpen,
    tableModalContent,
    setTableModalContent
  };

  return (
    <TableModalContext.Provider value={context}>
      {children}
    </TableModalContext.Provider>
  );
};

export function useTableModalContext(): TableModalContextProps {
  const context = TableModalContext;
  if (!context) {
    console.error('There is an error with tableModal context');
  }
  return useContext(context) as TableModalContextProps;
}
